import { getIntrospectionQuery, buildClientSchema, parse, } from 'graphql';
import AggregateError from '@ardatan/aggregate-error';
import isPromise from 'is-promise';
function getSchemaFromIntrospection(introspectionResult) {
    var _a, _b;
    if ((_a = introspectionResult === null || introspectionResult === void 0 ? void 0 : introspectionResult.data) === null || _a === void 0 ? void 0 : _a.__schema) {
        return buildClientSchema(introspectionResult.data);
    }
    else if ((_b = introspectionResult === null || introspectionResult === void 0 ? void 0 : introspectionResult.errors) === null || _b === void 0 ? void 0 : _b.length) {
        if (introspectionResult.errors.length > 1) {
            var combinedError = new AggregateError(introspectionResult.errors);
            throw combinedError;
        }
        var error = introspectionResult.errors[0];
        throw error.originalError || error;
    }
    else {
        throw new Error('Could not obtain introspection result, received: ' + JSON.stringify(introspectionResult));
    }
}
export function introspectSchema(executor, context, options) {
    var parsedIntrospectionQuery = parse(getIntrospectionQuery(options));
    var introspectionResult = executor({
        document: parsedIntrospectionQuery,
        context: context,
    });
    if (isPromise(introspectionResult)) {
        return introspectionResult.then(function (introspection) { return getSchemaFromIntrospection(introspection); });
    }
    return getSchemaFromIntrospection(introspectionResult);
}
// Keep for backwards compability. Will be removed on next release.
export function introspectSchemaSync(executor, context, options) {
    return introspectSchema(executor, context, options);
}
//# sourceMappingURL=introspect.js.map